var CUSTOM_CONFIG = {
    isLocal:false,
    name:"矿压智能监测预警平台",
    wMap:"",
    title:()=> {
        if (CUSTOM_CONFIG.isLocal) {
            return CUSTOM_CONFIG.name;
        } else {
            return "冲击矿压风险智能判识与多参量监测预警云平台";
        }
    },
    warnTag:()=>{
        if (CUSTOM_CONFIG.isLocal) {
            return "具有强危险";
        } else
            return "具有强冲击危险";
    },
    warnStats:()=>{
        if (CUSTOM_CONFIG.isLocal) {
            return "危险状态";
        } else
            return "冲击危险状态";
    },
    CUMT_Name:()=>{
        if (CUSTOM_CONFIG.isLocal) {
            return "";
        } else
            return "中国矿业大学冲击矿压大数据中心";

    },
    strainEnergyTag:()=>{
        if (CUSTOM_CONFIG.isLocal) {
            return "矿压变形能";
        } else
            return "冲击变形能";
    },
    strainEnergyKRI:()=>{
        if (CUSTOM_CONFIG.isLocal) {
            return "变形能空间预警";
        } else
            return "冲击变形能空间预警";
    },
    dayReportName:()=>{
        if (CUSTOM_CONFIG.isLocal) {
            return "矿压综合监测预警日报表";
        } else
            return "冲击地压综合监测预警日报表";
    },
    MaxQuake30:()=>{
        if (CUSTOM_CONFIG.isLocal) {
            return "最大能量事件";
        } else
            return "最大矿震";
    },
    FaceReportOrg:()=>{
        if (CUSTOM_CONFIG.isLocal) {
            return "矿压办";
        } else
            return "防冲办";
    },
    FaceReportName:()=>{
        if (CUSTOM_CONFIG.isLocal) {
            return "矿压副总";
        } else
            return "防冲负责人";
    },
}



//////////////////
// WEBPACK FOOTER
// ./static/custom_config.js?v=Math.randowm()
// module id = 1653
// module chunks = 50